import request from "@/common/request";

const api = {
	config : async function  (method, data={}){
		let res = await request.post('config',method,data);
		return res;
	},
	login : async function  (method,data={}){
		let res = await request.post('login',method,data);
		return res;
	},
	company : async function  (method,data={}){
		let res = await request.post('company',method,data);
		return res;
	},
	brand : async function  (method,data={}){
		let res = await request.post('brand',method,data);
		return res;
	},
	goods : async function  (method,data={}){
		let res = await request.post('goods',method,data);
		return res;
	},
	admin : async function  (method, data={}){
		let res = await request.post('admin',method,data);
		return res;
	},
	join : async function  (method, data={}){
		let res = await request.post('join',method,data);
		return res;
	},
	setting : async function  (method, data={}){
		let res = await request.post('setting',method,data);
		return res;
	},
	page : async function  (method, data={}){
		let res = await request.post('page',method,data);
		return res;
	},
	ebook : async function  (method, data={}){
		let res = await request.post('ebook',method,data);
		return res;
	},
	pdf_upload:async function  (file, dir=''){
		let res = await request.pdf_upload(file,dir);
		return res;
	},
	upload : async function  (file,method='', dir='',uid=''){
		let res = await request.upload(file,method,dir,uid);
		return res;
	},
	upload_list : async function  (method,data={}){
		let res = await request.post('upload',method,data);
		return res;
	},
	upload_get : async function  (method,data={}){
		let res = await request.post('upload',method,data);
		return res;
	},
	help : async function  (method,data={}){
		let res = await request.post('help',method,data);
		return res;
	},
	order : async function  (method,data={}){
		console.log(data);
		let res = await request.post('order',method,data);
		return res;
	},
	user : async function  (method,data={}){
		console.log(data);
		let res = await request.post('user',method,data);
		return res;
	},
	dis : async function  (method,data={}){
		console.log(data);
		let res = await request.post('dis',method,data);
		return res;
	},
	server : async function  (method,data={}){
		console.log(data);
		let res = await request.post('server',method,data);
		return res;
	},
	version : async function  (method,data={}){
		console.log(data);
		let res = await request.post('version',method,data);
		return res;
	},
};

export default api;
